import React, { useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import device1 from "../../assets/images/device1.png";
import device2 from "../../assets/images/device2.png";
import device3 from "../../assets/images/device3.png";

// ✅ Defined outside component — stable reference, never recreated on re-render
const sampleImages = [device1, device2, device3];

const Device = () => {
  const fileInputRef = useRef(null);
  const imagePreviewRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);

  // ✅ Replaced addEventListener with React's onChange — cleaner and no manual cleanup needed
  const handleFileChange = useCallback((event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      setSelectedImage(e.target.result);
      if (imagePreviewRef.current) {
        imagePreviewRef.current.src = e.target.result;
      }
    };
    reader.readAsDataURL(file);
  }, []);

  const handleSampleClick = useCallback((imgSrc) => {
    setSelectedImage(imgSrc);
    if (imagePreviewRef.current) {
      imagePreviewRef.current.src = imgSrc;
    }
  }, []);

  const handleAddCustom = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  return (
    <section className="flex flex-col items-center justify-center py-24 px-4 md:px-10 lg:px-20">
      <p
        className="text-[#76cfff] font-poppins tracking-[4px] uppercase text-[18px] font-bold text-center mb-10"
        data-aos="fade-down"
      >
        Branding with your own design?
      </p>

      <h1
        className="text-white font-poppins uppercase font-semibold text-[60px] md:text-[120px] lg:text-[160px] leading-[1.1] text-center mb-10"
        data-aos="fade-down"
      >
        Try the device branding feature now
      </h1>

      {/* Sample Cards */}
      <div className="flex gap-4 mb-10" data-aos="fade-up">
        {sampleImages.map((imgSrc, index) => (
          <div
            key={index}
            onClick={() => handleSampleClick(imgSrc)}
            className={`w-24 h-24 md:w-32 md:h-32 rounded-lg border-2 cursor-pointer transition-all hover:scale-105 ${
              selectedImage === imgSrc
                ? "border-[#76cfff] shadow-lg shadow-[#76cfff]/50"
                : "border-gray-600"
            }`}
          >
            {/* ✅ Sample thumbnails — lazy loaded, fixed dimensions prevent layout shift */}
            <img
              src={imgSrc}
              alt={`Device sample ${index + 1}`}
              loading="lazy"
              decoding="async"
              fetchpriority="low"
              width={128}
              height={128}
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        ))}

        {/* Add Custom Card */}
        <div
          onClick={handleAddCustom}
          className="w-24 h-24 md:w-32 md:h-32 rounded-lg border-2 border-dashed border-[#76cfff] cursor-pointer transition-all hover:scale-105 hover:bg-[#76cfff]/10 flex items-center justify-center"
        >
          <svg
            className="w-12 h-12 text-[#76cfff]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
        </div>
      </div>

      {/* Device Preview */}
      <div
        className="relative w-[300px] md:w-[400px] lg:w-[600px] h-[700px] md:h-[800px] lg:h-[1400px] bg-black rounded border border-[#76cfff] shadow-md transform -rotate-y-6 transition-transform"
        data-aos="fade-down"
      >
        {/* ✅ Preview img — no src initially, only set when user picks an image */}
        <img
          ref={imagePreviewRef}
          id="image-preview"
          className="w-full h-full object-cover rounded"
          alt="Device preview"
          decoding="async"
        />
        <div className="absolute top-[100px] md:top-[150px] lg:top-[200px] left-[15%] w-[70%] h-[40%] bg-black rounded shadow-inner border-2 border-[#76cfff]" />
        <div className="absolute top-[40px] md:top-[60px] lg:top-[70px] left-1/2 transform -translate-x-1/2 w-[30px] md:w-[40px] lg:w-[50px] h-[30px] md:h-[40px] lg:h-[50px] rounded-full bg-black shadow-inner border-2 border-[#76cfff]" />
      </div>

      {/* ✅ Hidden file input — onChange instead of addEventListener */}
      <input
        type="file"
        ref={fileInputRef}
        id="file-input"
        accept="image/*"
        className="hidden"
        onChange={handleFileChange}
      />

      <h1
        className="w-full font-poppins text-white uppercase text-[80px] md:text-[120px] lg:text-[160px] leading-none text-left pt-10 md:pt-[100px] lg:pt-[150px]"
        data-aos="fade-right"
      >
        Want to try your{" "}
        <span className="italic font-playfair lowercase">frame design?</span>
      </h1>

      <Link
        to="/TryNow"
        className="w-[200px] md:w-[300px] lg:w-[350px] h-[40px] md:h-[60px] lg:h-[70px] text-[#76cfff] text-[20px] md:text-[36px] lg:text-[50px] font-bold font-poppins text-center mt-6"
        data-aos="fade-right"
        data-aos-delay="200"
      >
        Try it now
      </Link>
    </section>
  );
};

export default Device;